// extracted by mini-css-extract-plugin
export var close = "modal-window-module--close--21d5e";
export var content = "modal-window-module--content--8e13e";
export var questionnaire = "modal-window-module--questionnaire--a3581";
export var root = "modal-window-module--root--561d0";